module.exports = __webpack_public_path__ + "img/Garden refuse.a3dc09f2.svg";